module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }